import React from 'react';
import Link, { navigateTo } from 'gatsby-link';

const Projects = ({ projects, limit = 0, type = 'card-deck' }) => (
  <div className={type}>
    {projects.slice(0, limit ? limit : projects.length).map((item, index) => {
      return <div className='card' key={item.node.id}>
        <Link to={item.node.frontmatter.path}>
          <img className="card-img-top border-bottom" src={item.node.frontmatter.thumbnail} alt="Project Thumbnail" />
        </Link>
        <div className="card-body">
          <h5 className="card-title">{item.node.frontmatter.title}</h5>
          <p className="card-text">{item.node.frontmatter.description}</p>
        </div>
        <div className="cushy-bottom text-center">
          <Link to={item.node.frontmatter.path} className="btn btn-outline-info">
            View Details
        </Link>
        </div>
      </div>
    })}
  </div>
);

export default Projects;


// WEBPACK FOOTER //
// ./src/components/Projects.js